import { AdmissionType } from '@domain/admission';
import { calculateDefaultMaxCapacity } from '@utils/calculate-dafult-max-capacity/calculate-default-max-capacity';

export const formatItemsPerTransactionToBackend = ({
  min,
  max,
  quantity,
  type,
}: {
  min?: string;
  max?: string;
  quantity: number;
  type: AdmissionType;
}) => {
  const minItemsPerTransation = Number(min);
  let maxItemsPerTransaction = Number(max);
  if (!maxItemsPerTransaction) {
    const MAX_QUANTITY_BY_ADMISSION_TYPE = Number(calculateDefaultMaxCapacity(type));

    if (quantity && Number(quantity) < MAX_QUANTITY_BY_ADMISSION_TYPE) {
      maxItemsPerTransaction = Number(quantity);
    } else {
      maxItemsPerTransaction = MAX_QUANTITY_BY_ADMISSION_TYPE;
    }
  }

  return {
    min: minItemsPerTransation === 0 ? 1 : minItemsPerTransation,
    max: maxItemsPerTransaction,
  };
};
